function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from "react";
import { debounce } from "debounce";
import { ComboBox } from "@bolteu/kalep-react";
import { DataProviderUtils } from "../../utils/DataProviderUtils";
import { createFilterOptions } from "../../utils/MUIUtils";
import { useIsMounted } from "../../utils/useIsMounted";
// Utils
function mergeOptions() {
  for (var _len = arguments.length, optionArrays = new Array(_len), _key = 0; _key < _len; _key++) {
    optionArrays[_key] = arguments[_key];
  }
  var mapArrays = optionArrays.map(function (options) {
    return (options || []).map(function (_ref) {
      var value = _ref.value,
        title = _ref.title;
      return [value, title];
    });
  });
  return _toConsumableArray(new Map(mapArrays.flat())).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      value = _ref3[0],
      title = _ref3[1];
    return {
      value: value,
      title: title
    };
  });
}
function optionalSingleToArray(value) {
  return [].concat(value !== null && value !== void 0 ? value : []);
}
function useSelectedOptions(_ref4, options) {
  var value = _ref4.value,
    isMultiple = _ref4.multiple;
  var previousSelectedOptionsRef = React.useRef(isMultiple ? [] : null);
  var selectedOptions = React.useMemo(function () {
    var prevSelectedOptions = optionalSingleToArray(previousSelectedOptionsRef.current);
    var currentOptions = optionalSingleToArray(options);
    var values = optionalSingleToArray(value);
    var valueSet = new Set(values);
    var filteredOptions = currentOptions.filter(function (option) {
      return valueSet.has(option.value);
    });
    var newSelectedOptions = mergeOptions(values.map(function (item) {
      return {
        value: item !== null && item !== void 0 ? item : null
      };
    }), filteredOptions);
    var _map = [prevSelectedOptions, newSelectedOptions].map(function (items) {
        return items.map(function (item) {
          return "".concat(item.value, "_").concat(item.title);
        }).sort().join();
      }),
      _map2 = _slicedToArray(_map, 2),
      prevSelectedOptionsStr = _map2[0],
      newSelectedOptionsStr = _map2[1];
    if (prevSelectedOptionsStr === newSelectedOptionsStr) {
      return isMultiple ? previousSelectedOptionsRef.current : prevSelectedOptions[0];
    }
    return isMultiple ? newSelectedOptions : newSelectedOptions[0];
  }, [isMultiple, options, value]);
  previousSelectedOptionsRef.current = selectedOptions;
  return selectedOptions;
}
function isOptionEqualToValue(option, valueOption) {
  return option.value === valueOption.value;
}
// Component
export var AutocompleteField = function AutocompleteFieldComponent(props) {
  var _a, _b, _c;
  var isCompact = props.compact,
    onChange = props.onChange,
    value = props.value,
    validatorResults = props.validatorResults,
    isMultiple = props.multiple,
    _props$commaSeparated = props.commaSeparated,
    isCommaSeparated = _props$commaSeparated === void 0 ? true : _props$commaSeparated,
    isFreeSolo = props.freeSolo,
    _props$mergeFreeSoloV = props.mergeFreeSoloValueWithOptions,
    shouldMergeFreeSoloValueWithOptions = _props$mergeFreeSoloV === void 0 ? true : _props$mergeFreeSoloV,
    name = props.name,
    label = props.label,
    optionsProp = props.options,
    rest = __rest(props, ["compact", "onChange", "value", "validatorResults", "multiple", "commaSeparated", "freeSolo", "mergeFreeSoloValueWithOptions", "name", "label", "options"]);
  var validationError = validatorResults === null || validatorResults === void 0 ? void 0 : validatorResults[0];
  var _React$useState = React.useState(""),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    searchValue = _React$useState2[0],
    setSearchValue = _React$useState2[1];
  var _React$useState3 = React.useState([]),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    options = _React$useState4[0],
    setOptions = _React$useState4[1];
  var updateOptions = React.useCallback(function (newOptions) {
    if (isFreeSolo && shouldMergeFreeSoloValueWithOptions) {
      setOptions(function (currentOptions) {
        var hasSearchValueInOptions = currentOptions === null || currentOptions === void 0 ? void 0 : currentOptions.some(function (item) {
          return item.title === searchValue || item.value === searchValue;
        });
        return mergeOptions(hasSearchValueInOptions || !searchValue ? [] : [{
          value: searchValue
        }], optionalSingleToArray(value).map(function (item) {
          return {
            value: item !== null && item !== void 0 ? item : null
          };
        }), newOptions);
      });
      return;
    }
    setOptions(newOptions);
  }, [isFreeSolo, searchValue, shouldMergeFreeSoloValueWithOptions, value]);
  var selectedOptions = useSelectedOptions(props, options);
  var optionValueByTitle = React.useMemo(function () {
    return new Map((options || []).map(function (option) {
      return [typeof option.title === "function" ? option.title() : option.title, option.value];
    }));
  }, [options]);
  var handleInputChange = React.useCallback(function (_ref5) {
    var inputValue = _ref5.target.value;
    if (isMultiple && isCommaSeparated && inputValue.includes(",")) {
      var addingValues = inputValue.split(",").map(function (item) {
        return item.trim();
      }).filter(Boolean).map(function (item) {
        return (optionValueByTitle.has(item) ? optionValueByTitle.get(item) : item) || null;
      });
      if (!isFreeSolo) {
        addingValues = addingValues.filter(function (item) {
          return (options || []).some(function (option) {
            return option.value === item;
          });
        });
      }
      if (addingValues.length) {
        onChange({
          value: optionalSingleToArray(selectedOptions).map(function (item) {
            return item.value;
          }).concat(addingValues)
        });
        setSearchValue("");
        return;
      }
    }
    setSearchValue(inputValue);
  }, [isCommaSeparated, isFreeSolo, isMultiple, onChange, optionValueByTitle, options, selectedOptions]);
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    isInitialized = _React$useState6[0],
    setInitialized = _React$useState6[1];
  var componentIsMounted = useIsMounted();
  var loadOptions = React.useMemo(function () {
    return debounce(function (input, callback) {
      DataProviderUtils.resolve(optionsProp, input).then(function (result) {
        return callback(null, result);
      })["catch"](function (error) {
        return callback(error);
      });
    }, 300);
  }, [optionsProp]);
  React.useEffect(function () {
    // Options array passed by props should always keep options up to date
    if (Array.isArray(optionsProp)) {
      updateOptions(optionsProp);
    }
    if (!isInitialized) {
      setInitialized(true);
      DataProviderUtils.resolve(optionsProp, undefined).then(function (result) {
        return updateOptions(result);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- it shouldn't be provoked by updateOptions change
  }, [isInitialized, optionsProp]);
  React.useEffect(function () {
    var isActive = true;
    loadOptions(searchValue, function (_error, newOptions) {
      if (componentIsMounted.current && isActive) {
        updateOptions(newOptions);
      }
    });
    return function () {
      isActive = false;
    };
  }, [searchValue, componentIsMounted, loadOptions, isFreeSolo, updateOptions]);
  var getOptionLabel = React.useCallback(function (option) {
    var _a;
    if (!option) {
      return "";
    }
    if (option.title !== undefined) {
      return DataProviderUtils.resolveSync(option.title, (_a = option.value) !== null && _a !== void 0 ? _a : "");
    }
    if (option.value !== undefined) {
      return String(option.value);
    }
    return "";
  }, []);
  var handleChange = React.useCallback(function (option) {
    var values = optionalSingleToArray(option).map(function (item) {
      return typeof item === "string" ? item : item === null || item === void 0 ? void 0 : item.value;
    });
    if (isMultiple) {
      onChange({
        value: values
      });
    } else {
      onChange({
        value: values[0]
      });
      setSearchValue(String(values[0] || ""));
    }
  }, [isMultiple, onChange]);
  var labelValue = (_a = props.label) !== null && _a !== void 0 ? _a : props.name;
  return /*#__PURE__*/React.createElement(ComboBox, Object.assign({
    label: labelValue,
    id: String(name),
    options: options !== null && options !== void 0 ? options : [],
    value: selectedOptions !== null && selectedOptions !== void 0 ? selectedOptions : null,
    loading: !options,
    onChange: handleChange,
    getOptionLabel: getOptionLabel,
    filterOptions: (_b = props.filterOptions) !== null && _b !== void 0 ? _b : props.filterOptionsConfig && createFilterOptions(props.filterOptionsConfig),
    multiple: isMultiple,
    fullWidth: true,
    error: !!validationError,
    helperText: (_c = validationError && validationError.error) !== null && _c !== void 0 ? _c : props.helperText,
    name: String(name),
    onInputChange: handleInputChange,
    size: isCompact ? "sm" : undefined,
    isOptionEqualToValue: isOptionEqualToValue
  }, rest));
};